<template>
  <div class="accordions">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Accordions'
}
</script>
